export type selectOption = {
  name: string;
  value: string;
};

export enum CellType {
  ROW = 'ROW',
  STRING = 'STRING',
  INFO = 'INFO',
  NUMBER = 'NUMBER',
  FLOAT = 'FLOAT',
  MOBILE = 'MOBILE',
  PRICE = 'PRICE',
  STATUS = 'STATUS',
  DATE = 'DATE',
  REGISTER_DATE = 'REGISTER_DATE',
  TEST = 'TEST',
  ENUM = 'ENUM',
  ACTION = 'ACTION',
}

export type TableHeadType = {
  key: string;
  label: string;
  type: CellType;
  action?: any;
  options?: selectOption[];
};

export interface KeyValueProps {
  key: string;
  value: any;
  color?: string;
}

export type TProduct = {
  inventoryId?: number;
  productId: number;
  price: number;
  productName: string;
  productPic: string;
  shortDescription?: string;
  quantity?: number;
  off: number;
  productType: 0 | 1;
  doneTest?: boolean;
};
